

import React, { createContext, useContext, useState } from 'react';
import type { Company } from '@/lib/types/core';

// Temporarily define Assignment here if it's simple, or use 'any' if complex and widely used
// For now, using 'any' to avoid breaking the context structure immediately.
// A proper Assignment type from @/types will be needed later.
export type Assignment = unknown;

// Combine types for easier handling
export type AssignmentWithCompanies = Assignment & {
  orderingCompany: Company | null
  performingCompany: Company | null
}

type DialogTypes = 'add' | 'edit' | 'delete' | 'view' // Add more dialog types as needed

interface AssignmentsContextProps {
  open: DialogTypes | null
  setOpen: (_type: DialogTypes | null) => void
  currentRow: AssignmentWithCompanies | null
  setCurrentRow: (_assignment: AssignmentWithCompanies | null) => void
}

const AssignmentsContext = createContext<AssignmentsContextProps | undefined>(
  undefined
);

export function AssignmentsProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState<DialogTypes | null>(null);
  const [currentRow, setCurrentRow] = useState<AssignmentWithCompanies | null>(null);

  return (
    <AssignmentsContext.Provider
      value={{ open, setOpen, currentRow, setCurrentRow }}
    >
      {children}
    </AssignmentsContext.Provider>
  );
}

export function useAssignments() {
  const context = useContext(AssignmentsContext);
  if (context === undefined) {
    throw new Error('useAssignments must be used within a AssignmentsProvider');
  }
  return context;
} 